import { Link } from 'react-router-dom';

export default function Footer() {
  const handleConsultClick = () => {
    window.open('https://pf.kakao.com/_xnekRX/chat', '_blank', 'noopener,noreferrer');
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
          {/* Brand Column */}
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/e1589dec-861a-445d-ba4d-901f8503ac73.png"
              alt="유흥디자인랩"
              className="h-10 w-auto mb-4"
            />
            <div className="space-y-2 text-sm text-gray-400">
              <p className="text-gray-400 mb-6 leading-relaxed">
                유흥업계 전문 광고·홍보 디자인 서비스<br />
                구인광고부터 업체 홍보까지, 1~3일 완성
              </p>
              <button
                onClick={handleConsultClick}
                className="bg-neon-pink text-white px-6 py-3 rounded-full font-bold hover:bg-neon-pink/90 hover:scale-105 transition-all inline-flex items-center gap-2 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-kakao-talk-fill text-xl"></i>
                카카오톡 상담
              </button>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-4">빠른 링크</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/services"
                  className="text-gray-400 hover:text-neon-pink transition-all hover:translate-x-2 inline-block"
                >
                  서비스
                </Link>
              </li>
              <li>
                <Link
                  to="/portfolio"
                  className="text-gray-400 hover:text-neon-pink transition-all hover:translate-x-2 inline-block"
                >
                  포트폴리오
                </Link>
              </li>
              <li>
                <Link
                  to="/pricing"
                  className="text-gray-400 hover:text-neon-pink transition-all hover:translate-x-2 inline-block"
                >
                  가격
                </Link>
              </li>
              <li>
                <Link
                  to="/reviews"
                  className="text-gray-400 hover:text-neon-pink transition-all hover:translate-x-2 inline-block"
                >
                  후기
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-bold text-lg mb-4">문의</h3>
            <ul className="space-y-3 text-gray-400">
              <li className="flex items-center gap-2 hover:text-neon-pink transition-colors">
                <i className="ri-kakao-talk-fill"></i>
                <span>카카오톡 상담</span>
              </li>
              <li className="flex items-center gap-2 hover:text-neon-pink transition-colors">
                <i className="ri-time-line"></i>
                <span>평일,주말 24시간 상담 가능</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8 flex justify-center">
          {/* 제거됨 */}
        </div>

        {/* Powered by Readdy - 최소화 */}
        <div className="text-center py-2">
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[10px] text-gray-300/30 hover:text-gray-400/40 transition-colors"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
